import { Component, effect, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SettingsTheme } from '../theme/settings-theme';
import { marker as _ } from '@vandres/ngx-translate-extract-marker';
import { UserSettingsStore } from '../../../../../state/user-settings.repository';
import { Tab, Tabs } from '../../../../../shared/components/ui/tabs/tabs';
import { TColorModes } from '../../../../../state/app.repository';
import { map } from 'rxjs';

@Component({
  selector: 'andor-theme-tabs',
  standalone: true,
  imports: [SettingsTheme, Tabs],
  templateUrl: './settings-theme-tabs.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './settings-theme-tabs.scss',
})
export class SettingsThemeTabs {
  userSettingsStore = inject(UserSettingsStore);
  tabs: Tab[] = [
    {
      id: 'dark',
      label: _('Dark Theme'),
    },
    {
      id: 'light',
      label: _('Light Theme'),
    },
  ];

  /** Writable so andor-tabs can update it; also kept in sync with colorMode$ */
  activeTab = signal<Tab>(
    this.tabs.find((tab) => tab.id === this.userSettingsStore.colorMode) ?? this.tabs[0]
  );

  constructor() {
    this.userSettingsStore.colorMode$
      .pipe(
        map((colorMode) => this.tabs.find((tab) => tab.id === colorMode) ?? this.tabs[0]),
        takeUntilDestroyed()
      )
      .subscribe((tab) => this.activeTab.set(tab));

    effect(() => {
      const tab = this.activeTab();
      if (tab.id !== this.userSettingsStore.colorMode) {
        this.userSettingsStore.update({ colorMode: tab.id as TColorModes });
      }
    });
  }
}
